
import { unidadesMedidaApi } from "../../apis";
import Swal from "sweetalert2";






export const listadoUnidadesMedida = async () => {
    try {
        const { data } = await unidadesMedidaApi.get('/');
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const crearOrEditarUnidadMedida = async (body) => {
    try {
        const { data } = await unidadesMedidaApi.post('/new', body);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}